import React from 'react';
import PropTypes from 'prop-types';
import {connect} from "react-redux";
import Error from "../../../components/common/Error/Error";
import Loading from "../../../components/common/Loading/Loading";
import {fetchApp} from '../../../store/apps/actions';
import style from '../../../styles/styles';
import {deletePointMedia, fetchPoint} from "../../../store/points/actions";
import MediasService from '../../../services/medias';
import MediaList from "../../../components/media/MediaList/MediaList";
import {deleteTrailMedia, fetchTrail} from "../../../store/trails/actions";
import {EntityType} from "../../../constants/openexplore";
import withTranslation from "../../../hoc/withTranslation";
import {EDIT_OPENEXPLORE_MEDIA_PAGE} from "../../../constants/routes";

export class MimeMediaListPage extends React.Component {

    static propTypes = {
        app: PropTypes.object,
        entity: PropTypes.object
    };

    componentWillMount() {
        this.fetch();
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.match !== nextProps.match) {
            this.fetch(nextProps.match.params.appId, nextProps.match.params.entityId)
        }

        if (nextProps.app && this.props.app !== nextProps.app && this.props.entity === null) {
            this.fetchEntity(nextProps.app.id, nextProps.match.params.entityId);
        }
    }

    // Fetch

    fetch(appId = null, entityId = null) {
        this.fetchApplication(appId);
        this.fetchEntity(appId, entityId);
    }

    fetchApplication(appId = null) {
        if (this.props.match) {
            const id = appId || this.props.match.params.appId;

            if (id) {
                this.props.fetchApp(id)
            }
        }
    }

    fetchEntity(appId = null, entityId = null) {
        if (this.props.match) {
            const app = appId || this.props.match.params.appId;
            const entity = entityId || this.props.match.params.entityId;

            if (app && entity) {
                switch (this.props.match.params.entityType) {
                    case EntityType.POINT:
                        this.props.fetchPoint(app, entity, this.props.lang);
                        break;

                    case EntityType.TRAIL:
                        this.props.fetchTrail(app, entity, this.props.lang);
                        break;

                    default:
                        break;
                }
            }
        }
    }

    // Handlers

    handleEditMedia = (media) => {
        let url = EDIT_OPENEXPLORE_MEDIA_PAGE
            .replace(':appId', this.props.app.id)
            .replace(':entityType', this.props.match.params.entityType)
            .replace(':entityId', this.props.entity.id)
            .replace(':mediaId', media.id);
        this.props.history.push(url);
    };

    handleDeleteMedia = (media) => {
        if (this.props.app && this.props.entity) {
            switch (this.props.match.params.entityType) {
                case EntityType.POINT:
                    this.props.deletePointMedia(this.props.app.id, this.props.entity.id, media);
                    break;

                case EntityType.TRAIL:
                    this.props.deleteTrailMedia(this.props.app.id, this.props.entity.id, media);
                    break;

                default:
                    break;
            }
        }
    };

    // Render

    render() {
        let shortMime = this.props.match.params.shortMime;

        if (this.props.error) {
            return (
                <Error
                    title={this.props.t('generic.error')}
                    subtitle={this.props.t('generic.error_loading')}
                    paper={true}
                />
            );
        } else if (this.props.loading || !this.props.app || !this.props.entity) {
            return <Loading paper={false}/>;
        } else {
            let medias = MediasService.sortedMediasForShortMime(this.props.entity.medias, shortMime);
            let mimeDisplayName = MediasService.displayNameForShortMime(shortMime);

            return (
                <div>
                    <h3 style={style.navigation}>{this.props.t('medias.media_plural')} / {mimeDisplayName} - {this.props.entity.name}</h3>
                    <MediaList
                        title={mimeDisplayName}
                        medias={medias}
                        handleDeleteMedia={this.handleDeleteMedia}
                        handleEditMedia={this.handleEditMedia}
                    />
                </div>
            );
        }
    }
}

function mapStateToProps(state, ownProps) {
    let props = {
        loading: state.apps.pending || state.points.pending || state.trails.pending,
        error: state.points.error || state.apps.error || state.trails.error,
        lang: state.ui.currentLang,
        app: state.apps.currentApplication,
        user: state.auth.content
    };

    switch (ownProps.match.params.entityType) {
        case EntityType.POINT:
            props.entity = state.points.currentPoint;
            break;

        case EntityType.TRAIL:
            props.entity = state.trails.currentTrail;
            break;

        default:
            break;
    }

    return props;
}

export default connect(mapStateToProps, {
    fetchApp,
    fetchPoint,
    fetchTrail,
    deletePointMedia,
    deleteTrailMedia
})(withTranslation(MimeMediaListPage));



// WEBPACK FOOTER //
// src/containers/openexplore/MimeMediaListPage/MimeMediaListPage.js